import { render, staticRenderFns } from "./CreateVirtualWalletModal.vue?vue&type=template&id=4d89aaff&scoped=true&"
import script from "./CreateVirtualWalletModal.vue?vue&type=script&lang=js&"
export * from "./CreateVirtualWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateVirtualWalletModal.vue?vue&type=style&index=0&id=4d89aaff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89aaff",
  null
  
)

export default component.exports